import React, { Component } from 'react';

import PropTypes from 'prop-types';
import MenuBar from '../../components/MenuBar/MenuBar';
import NewsViewer from '../../components/Login/NewsViewer';
import './css/MainSummary.css';
import Chart from 'chart.js';
import { getMainCookie, checkStatus, getFullDate, checkText } from '../../../util/util';
import RCPagination from '../../components/UserControl/Pagination/RCPagination';
import $ from 'jquery';
import { AlertCommit } from '../../Modals/AlertBar';
import OwnerPage from './OwnerPage';

import i18n from "../../../../i18n";
import { translate, withNamespaces } from 'react-i18next'

let u;
let token;
class MainSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowOwnerPage: false,
            currentPageSize: 10
        };
    }
    componentDidMount() {
        u = getMainCookie();
        token = u.token;
        console.log("uuu", u)
        //this.getChartUserLogin("d");
        this.getChartCarStatus();
        this.getSummary("ALL", 1, 10);
    }
    componentDidUpdate() {


    }

    getSummary(mode, page, size) {
        let thisCur = this;
        fetch("http://203.150.199.244/api/report/deviceOverallSummary/" + mode + "/" + page + "/" + size, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data", data)
            if (data.RESULT_DATA && data.RESULT_DATA.length > 0) {
                thisCur.setState(
                    {
                        sumAll: data.RESULT_DATA[0].summary.total,
                        sumLicense: data.RESULT_DATA[0].summary.update_license,
                        sumSpeedOver: data.RESULT_DATA[0].summary.speed_over,
                        sumOnline: data.RESULT_DATA[0].summary.online,
                        sumOffline: data.RESULT_DATA[0].summary.offline,
                        sumOnline_dlt: data.RESULT_DATA[0].summary.online_dlt,
                        sumDue_payment: data.RESULT_DATA[0].summary.due_payment,
                        sumMode: mode,
                        sumDetailList: data.RESULT_DATA[0].details,
                        currentPage: page,
                        currentPageSize: size,
                        totalPage: mode == "ALL" ? data.RESULT_DATA[0].summary.total : mode == "LICENSE" ? data.RESULT_DATA[0].summary.update_license
                            : mode == "ONLINE" ? data.RESULT_DATA[0].summary.online : mode == "OFFLINE" ? data.RESULT_DATA[0].summary.offline
                                : mode == "DLT" ? data.RESULT_DATA[0].summary.online_dlt : mode == "PAYMENT" ? data.RESULT_DATA[0].summary.due_payment : 0

                    });
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }

    handleChkCtxMainSumGroup(e) {
        // this.getChartCarStatus();
        // if(e.target.checked)
        //     this.getChartUserLogin("y");
        // else
        //     this.getChartUserLogin("d");
    }

    getChartCarStatus() {
        let thisCur = this;

        fetch("http://203.150.199.244/api/report/getTrackingStatusSummary", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            let labels = [];
            let values = [];
            if (data.RESULT_DATA) {
                labels.push("เร็ว(" + data.RESULT_DATA[0].speed_over + ")");
                values.push(data.RESULT_DATA[0].speed_over);
                labels.push("วิ่ง(" + data.RESULT_DATA[0].moving + ")");
                values.push(data.RESULT_DATA[0].moving);
                labels.push("จอด(" + data.RESULT_DATA[0].stop + ")");
                values.push(data.RESULT_DATA[0].stop);
                labels.push("ดับ(" + data.RESULT_DATA[0].parking + ")");
                values.push(data.RESULT_DATA[0].parking);
                labels.push("เสา(" + data.RESULT_DATA[0].gsm + ")");
                values.push(data.RESULT_DATA[0].gsm);
            }
            var ctx = document.getElementById("ctxMainSum");
            if (!ctx)
                return;
            var myChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        // label: '# สถานะรถ',
                        data: values,
                        backgroundColor: [
                            '#dc3545c2',
                            '#28a745c2',
                            '#17a2b8c2',
                            '#6c757dc2',
                            '#000000c2'
                        ],
                        backgroundColor: [
                            '#dc3545',
                            '#28a745',
                            '#17a2b8',
                            '#6c757d',
                            '#000000'
                        ],
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: 'สถานะรถ'
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    }
                }
            });
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }

    getChartUserLogin(mode) {
        let thisCur = this;
        let n = 7;
        if (mode == "y")
            n = 6;
        fetch("http://203.150.199.244/api/report/getAccessSummary/" + mode + "/" + n, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            let labels = [];
            let values = [];
            if (data.RESULT_DATA) {
                for (let i = 0; i < data.RESULT_DATA.length; i++) {
                    labels.push(getFullDate(data.RESULT_DATA[i].access_dtm.replace(" 25", " ")));
                    values.push(data.RESULT_DATA[i].count);
                }
            }
            var ctx = document.getElementById("ctxMainSum");
            if (!ctx)
                return;
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: '# จำนวนการใช้ระบบ',
                        data: values,
                        backgroundColor: [
                            'rgba(255, 120, 0, 0.5)'
                        ],
                        borderColor: [
                            'rgba(255,120,0,1)'
                        ],
                        borderWidth: 1
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        position: 'top'
                    }
                }
            });
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }
    checkMode(mode) {
        if (mode == "ALL")
            return "รถทั้งหมด";
        else if (mode == "LICENSE")
            return "รถป้ายแดง";
        else if (mode == "PAYMENT")
            return "รถที่ครบกำหนด";
        else if (mode == "ONLINE")
            return "ออนไลน์";
        else if (mode == "OFFLINE")
            return "ไม่ออนไลน์เกิน 7 วัน";
        else if (mode == "DLT")
            return "ออนไลน์ไปขนส่ง";
        else if (mode == "SPEED")
            return "รถวิ่งเร็ว";
    }

    handleAllSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumAll .box").addClass("active");
        this.getSummary("ALL", 1, this.state.currentPageSize);
    }
    handleLicenseSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumLicense .box").addClass("active");
        if (u.user_level == 3 || u.user_level == 4)
            this.getSummary("SPEED", 1, this.state.currentPageSize);
        else
            this.getSummary("LICENSE", 1, this.state.currentPageSize);
    }
    handleOnlineSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumOnline .box").addClass("active");
        this.getSummary("ONLINE", 1, this.state.currentPageSize);
    }
    handleOfflineSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumOffline .box").addClass("active");
        this.getSummary("OFFLINE", 1, this.state.currentPageSize);
    }
    handleDLTSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumDLT .box").addClass("active");
        this.getSummary("DLT", 1, this.state.currentPageSize);
    }
    handlePaymentSelect() {
        $(".sum-card .box").removeClass("active");
        $("#dvSumPayment .box").addClass("active");
        this.getSummary("PAYMENT", 1, this.state.currentPageSize);
    }

    onPageSelect(page) {
        const { currentPageSize, sumMode } = this.state;
        this.getSummary(sumMode, page, currentPageSize);
    }
    onPageSizeChange(page, pageSize) {
        const { sumMode } = this.state;
        this.getSummary(sumMode, page, pageSize);
    }
    handleEdit(device_id) {
        this.refs.txtDeviceID.value = device_id;
        this.refs.dvEditDLTAlert.innerHTML = "";
        this.refs.txtEditDLT_remark.value = "";
    }
    callEditDLT() {
        let currentComponent = this;
        this.refs.dvEditDLTAlert.innerHTML = "";
        if (this.refs.txtEditDLT_remark.value.trim() === "") {
            this.refs.dvEditDLTAlert.innerHTML = "กรุณาใส่สาเหตุ";
            return;
        }
        fetch("http://203.150.199.244/api/admin/setDeviceChangeDetail/" + this.refs.txtDeviceID.value, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "special_setting.change_detail": this.refs.txtEditDLT_remark.value.trim()
            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data", data)
            if (data.RESULT_STATUS == "000")
                AlertCommit(true, "บันทึกข้อมูลเรียบร้อยแล้ว");
            else {
                AlertCommit(false, data.RESULT_STATUS + ": " + data.RESULT_MESSAGE);
            }
            this.getSummary("OFFLINE", 1, this.state.currentPageSize);
            currentComponent.btnEditDLTClose.click();
        },
            (error) => {
                console.log("error", error)
                return error;
                currentComponent.btnEditDLTClose.click();
            }

        )

    }
    gotoOwnerPage() {
        this.setState({
            isShowOwnerPage: true
        })
    }
    handleOwnerPageExit() {
        this.getChartCarStatus();
        this.setState({
            isShowOwnerPage: false
        })
    }

    render() {
        let { t } = this.props;
        let rows = [];
        if (this.state.sumDetailList) {
            if (u.user_level == 3 || u.user_level == 4) {
                this.state.sumDetailList.map((detail, index) => {
                    rows.push(
                        <div className="row row-list" key={"sumMain" + index}>
                            <div className="col-6">
                                <span className="index">{(this.state.currentPage - 1) * this.state.currentPageSize + (++index)}</span>
                                <span className="device-no">{detail.device_no}</span>
                                <span className="exp-date"><i className="fa fa-clock-o"> {detail.install_date}-{detail.expire_date}</i></span>
                                {
                                    this.state.sumMode == "OFFLINE" && detail.is_update_change_detail ?
                                        <button type="button" class="btn btn-danger btn-block btn-sm" style={{ paddingTop: 0, paddingBottom: 0 }}
                                            data-title="Edit" data-toggle="modal" data-target="#editDLT" onClick={this.handleEdit.bind(this, detail.device_id)}>แจ้งสาเหตุ</button>
                                        : null
                                }


                            </div>
                            <div className="col-6 icon-sum" style={{ textAlign: "right" }}>
                                <div>
                                    <i class="fas fa-car-side text-success" data-toggle="tooltip" title="จำนวนเวลารถวิ่ง" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถวิ่ง">{detail.moving} </span>
                                    <i class="far fa-dizzy text-danger" data-toggle="tooltip" title="จำนวนเวลาเร็วเกินกำหนด" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลาเร็วเกินกำหนด">{detail.speed_over}</span>
                                </div>
                                <div>
                                    <i class="fas fa-car-side text-info" data-toggle="tooltip" title="จำนวนเวลารถจอด" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถจอด">{detail.stop_machine_on} </span>
                                    <i class="fas fa-car-side text-secondary" data-toggle="tooltip" title="จำนวนเวลารถดับ" style={{ marginRight: 0 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถดับ">{detail.machine_off}</span>
                                </div>


                            </div>

                        </div>
                    );
                });
            } else {
                this.state.sumDetailList.map((detail, index) => {
                    rows.push(
                        <div className="row row-list" key={"sumMain" + index}>
                            <div className="col-5 col-sm-3">
                                <span className="index">{(this.state.currentPage - 1) * this.state.currentPageSize + (++index)}</span>
                                <span className="device-no">{detail.device_no}</span>
                                <span className="exp-date"><i className="fa fa-clock-o"> {detail.install_date}-{detail.expire_date}</i></span>
                                {
                                    this.state.sumMode == "OFFLINE" && detail.is_update_change_detail ?
                                        <button type="button" class="btn btn-danger btn-block btn-sm" style={{ paddingTop: 0, paddingBottom: 0 }}
                                            data-title="Edit" data-toggle="modal" data-target="#editDLT" onClick={this.handleEdit.bind(this, detail.device_id)}>แจ้งสาเหตุ</button>
                                        : null
                                }


                            </div>
                            <div className="col-sm-3 icon-sum d-none d-sm-inline-block" style={{ textAlign: "right" }}>
                                <div>
                                    <i class="fas fa-car-side text-success" data-toggle="tooltip" title="จำนวนเวลารถวิ่ง" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถวิ่ง">{detail.moving} </span>
                                    <i class="far fa-dizzy text-danger" data-toggle="tooltip" title="จำนวนเวลาเร็วเกินกำหนด" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลาเร็วเกินกำหนด">{detail.speed_over}</span>
                                </div>
                                <div>
                                    <i class="fas fa-car-side text-info" data-toggle="tooltip" title="จำนวนเวลารถจอด" style={{ marginRight: 3 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถจอด">{detail.stop_machine_on} </span>
                                    <i class="fas fa-car-side text-secondary" data-toggle="tooltip" title="จำนวนเวลารถดับ" style={{ marginRight: 0 }}></i>
                                    <span data-toggle="tooltip" title="จำนวนเวลารถดับ">{detail.machine_off}</span>
                                </div>


                            </div>
                            <div className="col-7 col-sm-6">
                                <span className="exp-user"><b className="d-none d-sm-inline-block">ตัวแทน:</b>
                                    <i style={{ color: "#ff7800" }} class="d-inline-block d-sm-none fa fa-handshake-o"></i> {checkText(detail.dealer, "-", 50)}</span>
                                <span className="exp-user"><b className="d-none d-sm-inline-block">ตัวแทนย่อย:</b>
                                    <i style={{ marginLeft: 2, marginRight: 1, color: "#ff7800" }} class="d-inline-block d-sm-none fa fa-users"></i> {checkText(detail.sub_dealer, "-", 50)}</span>
                                <span className="exp-user"><b className="d-none d-sm-inline-block">ผู้ใช้:</b>
                                    <i style={{ marginLeft: 4, marginRight: 7, color: "#ff7800" }} class="d-inline-block d-sm-none fa fa-user"></i>{checkText(detail.customer, "-", 50)}</span>
                            </div>
                        </div>
                    );
                });
            }

        }


        return (

            <div>
                <MenuBar tab_main="active" />

                <div className="main " style={{ position: "relative", top: 70 }}>
                    <div className="row text-right">


                    </div>
                    {
                        this.state.isShowOwnerPage &&
                        <OwnerPage onExitPage={this.handleOwnerPageExit.bind(this)} token={token}></OwnerPage>
                    }
                    {
                        !this.state.isShowOwnerPage &&
                        <div className="row " style={{ height: 0 }}>
                            <div className="col-12 col-md-12 col-lg-10 offset-lg-1">
                                <div className="row vertical-align" style = {{alignItems: "self-start"}}>
                                    <div className="col-12 col-md-6">
                                        <div className="row ">
                                            {/* <div className="col-12 sum-card all">
                                    <div className="box"><stong>2,530<span>คัน</span></stong><b>รถทั้งหมด</b></div>
                                </div> */}
                                            <div id="dvSumAll" className="col-6 sum-card cat" onClick={this.handleAllSelect.bind(this)}>
                                                <div className="box row active">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fab fa-creative-commons-nd"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        <stong>{this.state.sumAll}<span>คัน</span></stong>

                                                    </div>
                                                    <div className="col-12 text-right">
                                                        <b>รถทั้งหมด</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="dvSumLicense" className="col-6 sum-card cat" onClick={this.handleLicenseSelect.bind(this)}>
                                                <div className="box row">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fas fa-car"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        
                                                        {
                                                            u == undefined || u.user_level == 3 || u.user_level == 4 ?
                                                                <stong>{this.state.sumSpeedOver}<span>{t("คัน")}</span></stong>
                                                                : <stong>{this.state.sumLicense}<span>{t("คัน")}</span></stong>
                                                        }
                                                    </div>
                                                    <div className="col-12 text-right">
                                                        {
                                                            u == undefined || u.user_level == 3 || u.user_level == 4 ?
                                                                <b>รถวิ่งเร็ว</b>
                                                                : <b>รถป้ายแดง</b>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                            <div id="dvSumOnline" className="col-6 sum-card cat" onClick={this.handleOnlineSelect.bind(this)}>
                                                <div className="box row">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fas fa-link"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        <stong>{this.state.sumOnline}<span>คัน</span></stong>

                                                    </div>
                                                    <div className="col-12 text-right">
                                                        <b>ออนไลน์</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="dvSumOffline" className="col-6 sum-card cat" onClick={this.handleOfflineSelect.bind(this)}>
                                                <div className="box row">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fas fa-unlink"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        <stong>{this.state.sumOffline}<span>คัน</span></stong>

                                                    </div>
                                                    <div className="col-12 text-right">
                                                        <b>ไม่ออนไลน์เกิน 7 วัน</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="dvSumDLT" className="col-6 sum-card cat" onClick={this.handleDLTSelect.bind(this)}>
                                                <div className="box row">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fas fa-upload"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        <stong>{this.state.sumOnline_dlt}<span>คัน</span></stong>

                                                    </div>
                                                    <div className="col-12 text-right">
                                                        <b>ออนไลน์ไปขนส่ง</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="dvSumPayment" className="col-6 sum-card cat" onClick={this.handlePaymentSelect.bind(this)}>
                                                <div className="box row">
                                                    <div className="col-4" style={{ margin: "auto", textAlign: "center" }}>
                                                        <i class="fas fa-hourglass-end"></i>
                                                    </div>
                                                    <div className="col-8">
                                                        <stong>{this.state.sumDue_payment }<span>คัน</span></stong>

                                                    </div>
                                                    <div className="col-12 text-right">
                                                        <b>รถที่ครบกำหนด</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">{this.checkMode(this.state.sumMode)}</div>
                                            <div className="col-12 " style={{ minHeight: 350, maxHeight: 500, overflowY: "auto", marginRight:5 }}>
                                                {
                                                    rows
                                                }
                                            </div>
                                            <div className="col-12" style={{ marginTop: 5 }} >
                                                <RCPagination
                                                    onSelect={this.onPageSelect.bind(this)}
                                                    onShowSizeChange={this.onPageSizeChange.bind(this)}
                                                    total={this.state.totalPage}
                                                    currentPage={this.state.currentPage}
                                                    pageSize={this.state.currentPageSize}
                                                    isSimple={true}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="row" >
                                            {
                                                (u != undefined && u.user_level == 0 && !this.state.isShowOwnerPage) &&
                                                <div onClick={this.gotoOwnerPage.bind(this)} style={{ cursor: "pointer" }}><h6>
                                                    <b style={{ textDecoration: "underline", color: "#0a448e" }}>Owner Only</b></h6></div>
                                            }
                                            <div className="col-12 chart" style={{ backgroundColor: "#fff" }}>
                                                {/* <div className="pull-right" style={{top:-7,right:10}}>
                                                    <span style={{position:"relative"}}>วัน</span>
                                                    <label className="switch">
                                                        <input type="checkbox" onChange={this.handleChkCtxMainSumGroup.bind(this)}/>
                                                        <span className="slider"></span>
                                                        
                                                    </label>
                                                    <span style={{position:"relative"}}>เดือน</span>
                                                </div> */}
                                                <canvas id="ctxMainSum" width="230" ></canvas>
                                            </div>

                                            <div className="col-12 login new" style={{ backgroundColor: "#fff", marginTop: 15, minHeight: 500, maxHeight: 500, overflowY: "auto" }}>
                                                <h5>
                                                    กระดานข่าว
                                                </h5>
                                                <hr></hr>
                                                <NewsViewer />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>


                <div className="modal fade" id="editDLT" tabIndex={-1} role="dialog" aria-labelledby="editDLT" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading"> แจ้งสาเหตุออฟไลน์เกิน 7 วัน ให้ขนส่งฯ</h4>
                                <button ref={input => this.btnEditDLTClose = input} type="button" className="close" style={{ padding: 0, margin: 0 }} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">สาเหตุ</label>
                                    <div className="col-md-9">
                                        <textarea ref="txtEditDLT_remark" className="form-control" id="example-text-input" rows={3} defaultValue={""} />
                                    </div>
                                </div>
                                <div ref="dvEditDLTAlert" className='textAlert'></div>
                            </div>
                            <div className="modal-footer ">
                                <button onClick={this.callEditDLT.bind(this)} type="button" className="btn btn-primary btn-lg" style={{ width: '100%' }} ><span className="fa fa-check" />&nbsp;แจ้งสาเหตุ</button>
                            </div>
                        </div>

                    </div>
                </div>
                <input type="hidden" ref="txtDeviceID" />
            </div>
        );
    }
}
//export default MainSummary;
export default withNamespaces('MainSummary')(MainSummary);


// WEBPACK FOOTER //
// ./src/app/view/containers/MainSummary/MainSummary.js